module.exports = __webpack_public_path__ + "img/vip-icon-2.91602ae5.png";